import { createSlice } from "@reduxjs/toolkit";

const unlabelledStockSlice = createSlice({
    name:"unlabelledStocks",
    initialState:{
        unlabelledStock:null
    },
    reducers:{
        setUnlabelledList(state,action){
            state.unlabelledStock = [...(action?.payload)];
        },
    }
})


export const {setUnlabelledList} = unlabelledStockSlice.actions
export default unlabelledStockSlice.reducer